import axiosInstance from "../../routes/axiosConfig";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const OptionsService = {
  getOptionsByType: async (type) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}/options/${type}`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao buscar opções do tipo ${type}:`,
        error.response?.data || error.message
      );
      throw error;
    }
  },

  createOption: async (optionData) => {
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}/options`,
        optionData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao criar opção:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  updateOption: async (optionData) => {
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}/options`,
        optionData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao atualizar opção:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  deleteOption: async (optionsId) => {
    try {
      const response = await axiosInstance.delete(
        `${API_BASE_URL}/options/${optionsId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao deletar opção com ID ${optionsId}:`,
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default OptionsService;
